var _jsxFileName = "/codebuild/output/src4085722976/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/consents/LibreAssistConsent.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { IconBack, IconClose, InformationalScreen, LoadingModal, Stack } from '@adc/parallax-component-library';
import { APP_RETURN_TIMEOUT, ErrorCode } from 'Constants';
import { useApiError } from 'Hooks';
import { Button, Footer, MainContainer, OptInOut, RichText } from 'Components/utility';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { handleConsent } from 'Services/consent';
const mapStateToProps = ({
  env: {
    osType,
    osVersion,
    app,
    appVersion
  },
  auth,
  nav: {
    query
  }
}) => {
  return {
    osType,
    osVersion,
    app,
    appVersion,
    auth,
    isAccountProfile: !!query.accountProfile
  };
};
const connector = connect(mapStateToProps);
const LibreAssistConsent = ({
  osType,
  osVersion,
  app,
  appVersion,
  auth,
  isAccountProfile
}) => {
  var _auth$include$patient;
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const handleConsentWrapper = useCallback(async action => {
    return new Promise((resolve, reject) => {
      handleConsent(auth.account_id, action, osType, osVersion, app, appVersion, 'assist').then(resp => {
        const updatedAuthSession = {
          ...auth,
          include: {
            patient: {
              ...auth.include.patient,
              consents: {
                ...auth.include.patient.consents,
                assist: {
                  ...resp
                }
              }
            }
          }
        };
        notifyApp('adc-webview:consents', {
          id: 'assist',
          action,
          location: isAccountProfile ? 'profile' : 'tutorial'
        });
        store.dispatch({
          type: AUTH_SESSION,
          authSession: updatedAuthSession
        });
        resolve(updatedAuthSession);
      }).catch(error => {
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
        reject(error);
      });
    });
  }, [app, appVersion, auth, isAccountProfile, osType, osVersion, showApiErrorModal, showNetworkErrorModal]);
  const handleSubmitAction = useCallback(async action => {
    try {
      setLoading(true);
      await handleConsentWrapper(action);
      if (isAccountProfile) {
        // Ends the loading state if the user is on the account profile page
        setLoading(false);
        return;
      }

      // This timeout is added to give the app time to redirect the user back.
      setTimeout(() => {
        setLoading(false);
      }, APP_RETURN_TIMEOUT);
    } catch {
      setLoading(false);
    }
  }, [handleConsentWrapper, isAccountProfile]);
  const onDeclineButtonClick = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Consents.modals.declineAssistConsentDialog.body'),
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.goBack'),
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        primaryAction: {
          label: i18n.t('Global.microcopy.common.decline'),
          onPress: () => {
            handleSubmitAction('decline');
            store.dispatch({
              type: CLOSE_MODAL
            });
          },
          destructive: true
        },
        buttonLayout: 'column',
        testID: 'LibreAssist'
      }
    });
  }, [handleSubmitAction]);
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 5
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      animatedTitle: true,
      title: i18n.t('Consents.content.assistDataUse.primaryText'),
      buttonStart: {
        element: isAccountProfile ? /*#__PURE__*/React.createElement(IconBack, {
          testID: "LibreAssist.close-Pressable",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 165,
            columnNumber: 15
          }
        }) : /*#__PURE__*/React.createElement(IconClose, {
          testID: "LibreAssist.close-Pressable",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 167,
            columnNumber: 15
          }
        }),
        label: i18n.t('LibreAssist.close'),
        onPress: () => mediator.publish('router:back')
      }
    },
    testID: "LibreAssist",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 176,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    testID: "Consents.content.assistDataUse.bodyText",
    text: i18n.t('Consents.content.assistDataUse.bodyText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 11
    }
  }, isAccountProfile ? /*#__PURE__*/React.createElement(OptInOut, {
    optionStrings: {
      titleTag: 'Global.microcopy.common.status',
      positiveTag: 'Global.microcopy.common.accepted',
      negativeTag: 'Global.microcopy.common.declined',
      positiveOption: 'Global.microcopy.common.accept',
      negativeOption: 'Global.microcopy.common.decline'
    },
    initialState: !!((_auth$include$patient = auth.include.patient) !== null && _auth$include$patient !== void 0 && (_auth$include$patient = _auth$include$patient.consents) !== null && _auth$include$patient !== void 0 && (_auth$include$patient = _auth$include$patient.assist) !== null && _auth$include$patient !== void 0 && _auth$include$patient.accepted) ? 'accept' : 'decline',
    handleConsent: handleConsentWrapper,
    onDecline: onDeclineButtonClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 15
    }
  }) : /*#__PURE__*/React.createElement(Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    alignSelf: "flex-end",
    width: "100%",
    gap: "$4",
    marginBottom: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: () => handleSubmitAction('accept'),
    testID: "LibreAssist.accept",
    label: i18n.t('Global.microcopy.common.accept'),
    "aria-label": i18n.t('Global.microcopy.common.accept'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 201,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onPress: onDeclineButtonClick,
    label: i18n.t('Global.microcopy.common.decline'),
    "aria-label": i18n.t('Global.microcopy.common.decline'),
    testID: "LibreAssist.decline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 19
    }
  })))))));
};
export default connector(LibreAssistConsent);